module.exports = __webpack_public_path__ + "fonts/pmzd.67dedd33.ttf";